module.exports = __webpack_public_path__ + "static/img/d4_3.78d5ca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/d4_3.jpg
// module id = 2pw7
// module chunks = 0